import { getCSRCookieData } from '@/app/api/CSR/getCSRCookieData'
import { storage } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { DeadpoolUser } from '~types/index'
import { CART_FALLBACK, CART_ID } from '../constants'
import migrableGuestCart from './migrableGuestCart'

const db = storage('local')

export interface GetStoredCartIdProps {
  customer: DeadpoolUser | null
}
const getStoredCartId = ({ customer }: GetStoredCartIdProps) => {
  if (typeof window === 'undefined') {
    return null
  }
  let localSCartId: string | null = db.getItem(CART_ID) || null
  localSCartId = localSCartId === 'null' ? null : localSCartId
  let fallbackCartId: string | null =
    (!customer && getCSRCookieData(CART_FALLBACK)) || null
  fallbackCartId = fallbackCartId === 'null' ? null : fallbackCartId

  const storedCartId: string | null =
    migrableGuestCart({ db, customer, cartId: localSCartId }) || fallbackCartId
  return storedCartId
}

export default getStoredCartId
